import firebase from "firebaseConfig"

export const updateOrganizationLogo = (state) => {
  return (dispatch, getState, { getFirestore }) => {
    // make async call to database
    const user = firebase.auth().currentUser
    const storageRef = firebase.storage().ref()
    const firestore = getFirestore()
    const profileImagesRef = storageRef.child(`organization_logos/${user.uid}`)

    profileImagesRef.getDownloadURL().then(function (url) {
      user.updateProfile({
        photoURL: url,
      })
      firestore
        .collection("vcr/db/organization")
        .doc(user.uid)
        .update({ logo: url })
        .then(() => {
          dispatch({ type: "UPDATE_LOGO_SUCCESS" })
        })
        .catch((err) => {
          dispatch({ type: "UPDATE_LOGO_FAILED" }, err)
        })
    })
    profileImagesRef
      .putString(state.defaultPreview, "data_url")
      .then(function (snapshot) {
        dispatch({ type: "UPDATE_PROFILE_PICTURE_SUCCESS" })
      })
      .catch((err) => {
        dispatch({ type: "UPDATE_PROFILE_PICTURE_FAILED" }, err)
      })
  }
}

export const updateProfile = (state) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore()
    const user = firebase.auth().currentUser
    const profData = {
      name: state.name,
      manager: state.manager,
      type: state.type,
      address: state.address,
      city: state.city,
      country: state.country,
      postalCode: state.postalCode,
    }
    firestore
      .collection("vcr/db/organization")
      .doc(user.uid)
      .update(profData)
      .then(() => {
        dispatch({ type: "ORG_UPDATE_PROFILE_SUCCESS" })
      })
      .catch((err) => {
        console.log(err)
        dispatch({ type: "ORG_UPDATE_PROFILE_FAILED" }, err)
      })
  }
}

export const updateMerchant = (state) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore()
    const user = firebase.auth().currentUser
    return firestore
      .collection("merchants")
      .doc(user.uid)
      .update(state)
      .then(() => {
        console.log("Merchant Profile Successfully Updated.")
        dispatch({ type: "MERCHANT_PROFILE_UPDATED" })
        return true
      })
      .catch((err) => {
        console.log(`Error Updating Merchant Profile.\n${err}`)
        dispatch({ type: "MERCHANT_PROFILE_UPDATE_FAILED" })
        return false
      })
  }
}
